import { useMutation, useQueryClient } from '@tanstack/react-query';
import { API } from 'utils/globalApiServices';
import { toastFlashMessage } from 'utils';
import { ROLEPLAY_CACHE_KEYS } from 'features/roleplay/Roleplay.queries';

const mutationFn = async ({ assignment_uuid }) => {
  const url = `v2/roleplay/${assignment_uuid}/submit/`;
  const data = await API.post(url);
  return data;
};

const useSubmitRolePlayMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn,
    onSuccess: (response) => {
      toastFlashMessage(response?.message, 'success');
      toastFlashMessage(
        'Your Interactive Roleplay report is in progress. We will notify you as soon as it’s ready.',
        'info'
      );
      queryClient.invalidateQueries([ROLEPLAY_CACHE_KEYS.MY_TEAM]);
    },
  });
};

export default useSubmitRolePlayMutation;
